import { render } from "./vid-dog-pril-view.vue?vue&type=template&id=a6089208"
import script from "./vid-dog-pril-view.vue?vue&type=script&setup=true&lang=js"
export * from "./vid-dog-pril-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/components/forms/vid-dog-pril-form/vid-dog-pril-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6089208"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6089208', __exports__)) {
    api.reload('a6089208', __exports__)
  }
  
  module.hot.accept("./vid-dog-pril-view.vue?vue&type=template&id=a6089208", () => {
    api.rerender('a6089208', render)
  })

}


export default __exports__